export default __webpack_public_path__ + "static/media/spooky_hill_logo.0c5bcd58.svg";